import Name from './name'
import Photo from './photo'
import Position from './position'

const Card = ({ photo, name, position }) => {
  const base = "relative w-full flex flex-col gap-y-detailsMobile lg:gap-y-smallDesktop";
  return (
    <div className={base}>
      <Photo image={photo} />
      <Name text={name} />
      <Position text={position} />
    </div>
  )
}

export default Card
